export function getApiUrl(props) { 
    if (props && props.development) {
        return 'http://127.0.0.1:8000'
    }
    return 'https://api.chatengine.io'
}
